import { OrderStatus } from '@/models/ticket';
import { useTranslation } from 'react-i18next';

export const useTicketLabelTranslations = () => {
    const { t } = useTranslation();

    const getOrderStatusAsString = (status: OrderStatus) => {
        return t(`orderStatus.${status}`, { defaultValue: status });
    };

    return {
        getOrderStatusAsString,
    };
};
